import React, { Component } from "react";
import colors from "../../colors";
// import menu from "../data/data";//menu
import BudgetTable from "../../BudgetTable";

import Slider from "./Slider";
import MediaQuery from "react-responsive";

const budget = {
  header: [
    "2016-2017",
    "2017-2018",
    "2018-2019",
    "2019-2020",
    "2020-2021",
    "2021-2022",
    "2022-2023",
    "2023-2024",
  ],
  rows: {
    row1: [
      "Satellite Data",
      "2.0",
      "52.0",
      "2.0",
      "2.0",
      "2.0",
      "2.0",
      "2.0",
      "2.0",
      "66.0",
    ],
    row2: [
      "Field Experimentation & OutSoursing Activities",
      "0.0",
      "1.0",
      "2.0",
      "2.0",
      "2.0",
      "1.0",
      "1.0",
      "1.0",
      "10.0",
    ],
    row3: [
      "NRSC Manpower",
      "1.6",
      "5.1",
      "5.1",
      "5.1",
      "5.1",
      "5.1",
      "5.1",
      "5.1",
      "37.0",
    ],
    row4: [
      "Project Scientists",
      "0.0",
      "17.1",
      "17.1",
      "17.1",
      "17.1",
      "17.1",
      "17.1",
      "17.1",
      "119.7",
    ],
    row5: [
      "Data Analysis",
      "1.0",
      "1.0",
      "1.0",
      "1.0",
      "1.0",
      "1.0",
      "1.0",
      "1.0",
      "8.0",
    ],
    row6: [
      "Hardware & Software + Maintenance",
      "7.0",
      "17.0",
      "1.0",
      "2.5",
      "2.5",
      "2.5",
      "2.5",
      "2.5",
      "37.7",
    ],
    row7: [
      "ALT DEM / High Resolution Satellite DEM Generation",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row8: [
      "Travel & Field Works",
      "1.0",
      "2.0",
      "2.0",
      "2.0",
      "2.0",
      "2.0",
      "2.0",
      "2.0",
      "15.0",
    ],
    row9: [
      "Training & Workshops",
      "0.0",
      "3.0",
      "10.0",
      "5.0",
      "5.0",
      "0.0",
      "0.0",
      "0.0",
      "23.0",
    ],
    row10: [
      "Sub - Total 1",
      "12.6",
      "98.1",
      "40.2",
      "36.7",
      "36.7",
      "30.7",
      "30.7",
      "30.7",
      "316.4",
    ],
    row11: [
      "Project Management @ 5% of Sub - Total 1",
      "0.6",
      "4.9",
      "2.0",
      "1.8",
      "1.8",
      "1.5",
      "1.5",
      "1.5",
      "15.8",
    ],
    row12: [
      "Sub - Total 2",
      "13.3",
      "103.1",
      "42.2",
      "38.5",
      "38.5",
      "32.2",
      "32.2",
      "32.2",
      "332.2",
    ],
    row13: [
      "Organization Overheads @ 5% of Sub - Total 2",
      "0.7",
      "5.2",
      "2.1",
      "1.9",
      "1.9",
      "1.6",
      "1.6",
      "1.6",
      "16.6",
    ],
    row14: [
      "Grand Total",
      "13.9",
      "108.2",
      "44.3",
      "40.5",
      "40.5",
      "33.8",
      "33.8",
      "33.8",
      "348.8",
    ],
  },
};
export default class FLFinancialProposal extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
          height: "800px",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />

          <div className="card" style={{ flexGrow: "1", overflowX: "auto" }}>
            <MediaQuery minWidth={991}>
              <div
                className="card-body"
                style={{ margin: "auto", padding: "10px" }}
              >
                <h3 align="center" style={{ color: "#002171" }}>
                  Satellite data based inputs for Irrigation Scheduling for a
                  selected Irrigation Project command area
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
            <MediaQuery maxWidth={991}>
              <div className="card-body" style={{ padding: "10px" }}>
                <h3 align="center" style={{ color: "#002171" }}>
                  Satellite data based inputs for Irrigation Scheduling for a
                  selected Irrigation Project command area
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
          </div>
        </div>
      </div>
    );
  }
}
